import { render } from "./GeneralReport.vue?vue&type=template&id=f6f7ed06&scoped=true"
import script from "./GeneralReport.vue?vue&type=script&lang=js"
export * from "./GeneralReport.vue?vue&type=script&lang=js"

import "./GeneralReport.vue?vue&type=style&index=0&id=f6f7ed06&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f7ed06"]])

export default __exports__